import Vue from "vue"
const store = Vue.observable({
  nav: false,
  availabilityListing: null,
})

export const getters = {
  nav: {
    get: () => store.nav,
    set: (value) => (store.nav = value),
  },
  availabilityListing: {
    get: () => store.availabilityListing,
    set: (value) => (store.availabilityListing = value),
  },
}

export const actions = {
  open: () => {
    store.nav = true
    document.dispatchEvent(new Event("nav:open"))
  },
  close: () => {
    store.nav = false
    document.dispatchEvent(new Event("nav:close"))
  },
  toggle: (toggle, callback = null) => {
    toggle ? actions.open() : actions.close()

    callback && callback()
  },
  setAvailability: (listing) => (store.availabilityListing = listing),
  resetAvailability: () => actions.setAvailability(null),
}
